import {RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle} from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private storedRoutes = new Map<string, DetachedRouteHandle>();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // Example: Detach if route has data.reuse set to true
    return route.data?.reuse === true;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    if (handle) {
      this.storedRoutes.set(this.getRouteKey(route), handle);
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return !!this.storedRoutes.get(this.getRouteKey(route));
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return this.storedRoutes.get(this.getRouteKey(route)) || null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // console.log('reuse', 'future', future.routeConfig, 'current', curr.routeConfig, 'return: ', future.routeConfig === curr.routeConfig);
    // return future.routeConfig === curr.routeConfig;

    // console.log('shouldReuseRoute called',
    //   'future path:', future.routeConfig?.path,
    //   'future query params:', future.queryParams,
    //   'current path:', curr.routeConfig?.path,
    //   'current query params:', curr.queryParams);

    // force page to reload so we catch any instances of pages base being same and only query parameters change.
    return false;
  }

  // shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
  //   // Only reload the route if the route config itself changes
  //   return future.routeConfig === curr.routeConfig;
  // }


  private getRouteKey(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot.map(s => s.routeConfig && s.routeConfig.path).join('/');
  }
}
